import gsap, { Power2 } from 'gsap';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';

export class ScrollItem__BlockLanding extends ScrollItem__BlockDefault {
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }

    setAnimations() {
        super.setAnimations();

        this.img = GetBy.class('__img', this.item)[0];
        gsap.set(this.img, { opacity: 0 });

        const video = GetBy.selector('video', this.img)[0];
        if (video) {
            this.video = video;

            if (!isMobile) {
                this.videoThumbnail = GetBy.selector('#VideoThumbnail video')[0];
                this.videoThumbnail.src = this.video.src;
                this.videoThumbnail.pause();
                this.resize();
            }
        }
    }

    showFunction() {
        super.showFunction();

        gsap.to(this.img, {
            opacity: 1,
            duration: 1,
            ease: Power2.easeOut
        });

        if (this.videoThumbnail) {
            this.videoThumbnail.currentTime = this.video.currentTime;
            this.videoThumbnail.pause();

            gsap.to(this.videoThumbnail.parentNode, {
                x: '100%',
                duration: 1,
                ease: Power2.easeOut
            });
        }
    }

    hideFunction() {
        super.hideFunction();

        if (this.videoThumbnail) {
            this.video.currentTime = this.videoThumbnail.currentTime;
            this.videoThumbnail.play();

            gsap.to(this.videoThumbnail.parentNode, {
                x: 0,
                duration: 1,
                ease: Power2.easeOut
            });
        }
    }

    dispose() {
        super.dispose();

        if (this.videoThumbnail) {
            this.videoThumbnail.pause();

            gsap.to(this.videoThumbnail.parentNode, {
                x: '100%',
                duration: 1,
                ease: Power2.easeOut
            });
        }
    }

    resize() {
        super.resize();

        if (this.videoThumbnail) {
            const { height } = this.videoThumbnail.getBoundingClientRect();
            document.documentElement.style.setProperty('--video', `${height}px`);
        }
    }
}

Scroll._registerClass('BlockLanding', ScrollItem__BlockLanding);
